
import React, { useState, useEffect } from "react";
import api from "../../../utils/api";
import { Link } from "react-router-dom";
import "../casino/CasinoPage.css";
import "./ProvidersPage.css";

const ProvidersPage = () => {
    const [providers, setProviders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProviders = async () => {
            try {
                const res = await api.get("/providers?limit=1000");
                if (res.data.success) {
                    setProviders(res.data.data);
                }
            } catch (error) {
                console.error("Error fetching providers:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchProviders();
    }, []);

    const getImageUrl = (img) => {
        if (!img) return null;
        return img;
    };

    return (
        <div className="providers-page casino-page">
            {/* Banner / Header */}
            <div className="casino-banner-section" style={{ height: '250px' }}>
                <div className="provider-header-content">
                    <h1>Game Providers</h1>
                    <div className="providers-breadcrumb" style={{ marginTop: '10px' }}>
                        <Link to="/">Home</Link> / <span>Providers</span>
                    </div>
                </div>
            </div>

            {loading ? (
                <div className="loading-spinner">Loading Providers...</div>
            ) : (
                <div className="casino-games-container">
                    <div className="casino-games-grid">
                        {providers.map((provider) => (
                            <Link to={`/providers/${provider.slug}`} key={provider._id} className="provider-card">
                                <div className="provider-logo-wrapper">
                                    {provider.logo ? (
                                        <img
                                            src={getImageUrl(provider.logo)}
                                            alt={provider.name}
                                            className="provider-logo"
                                        />
                                    ) : (
                                        <span className="provider-name">{provider.name}</span>
                                    )}
                                </div>
                                <div className="provider-info-overlay">
                                    <h3>{provider.name}</h3>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProvidersPage;
